import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import SuccessMessage from 'srcReact/components/common2/SuccessMessage'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { organizationSettingsActions } from 'srcReact/OrganizationSettingsPage/actions'
import styles from './styles.module.scss'

function DeleteDocumentModal({ orgId, fileToDelete, closeModal }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    organizationSettings: {
      orgFiles: { loading, deleteFileError, deletedId, success }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (!loading && success && deletedId > 0) {
      setTimeout(() => {
        closeModal()
      }, 2000)
    }
  }, [loading, deletedId, success])
  useEffect(() => {
    return () => {
      dispatch(organizationSettingsActions.clearFlagsForOrgDocs())
    }
  }, [])

  const handleConfirm = () => {
    dispatch(organizationSettingsActions.deleteOrgFile(orgId, fileToDelete.id))
  }

  return (
    <React.Fragment>
      {fileToDelete?.file_info ? (
        <div className={styles.fileWithDownload}>
          <span className={styles.fileName}>{fileToDelete.file_info.name}</span>
          {/* <IconButton iconName='download' iconSize='large24' onClick={() => handleDownload(fileToDelete)} /> */}
        </div>
      ) : fileToDelete?.file_url ? (
        <a className={styles.fileName} href={fileToDelete.file_url} target='_blank'>
          {fileToDelete.file_url}
        </a>
      ) : null}

      <div className={styles.buttons}>
        <Button style='secondary' text={t('global.cancel')} handleClick={closeModal} />
        <Button text={t('global.confirm')} handleClick={handleConfirm} />
      </div>
      {deleteFileError && <ErrorMessage className={styles.error} text={deleteFileError} />}
      {success && (
        <SuccessMessage
          className={styles.success}
          text={t('organizationSettings.documents.successDelete', {
            type: fileToDelete?.file_url ? t('global.link') : t('global.document')
          })}
        />
      )}
    </React.Fragment>
  )
}

export default DeleteDocumentModal
